import React, { createContext, useContext } from 'react';
import { useComparison } from '@/hooks/useComparison';
import { Bot } from '@/types/Bot';

interface ComparisonContextType {
  comparisonList: Bot[];
  addToComparison: (bot: Bot) => void;
  removeFromComparison: (botId: string) => void;
  clearComparison: () => void;
  isInComparison: (botId: string) => boolean;
  canAddMore: boolean;
  maxItems: number;
}

const ComparisonContext = createContext<ComparisonContextType | undefined>(undefined);

export const useComparisonContext = () => {
  const context = useContext(ComparisonContext);
  if (!context) {
    throw new Error('useComparisonContext must be used within a ComparisonProvider');
  }
  return context;
};

interface ComparisonProviderProps {
  children: React.ReactNode;
}

export const ComparisonProvider: React.FC<ComparisonProviderProps> = ({ children }) => {
  const comparison = useComparison();

  return (
    <ComparisonContext.Provider value={comparison}>
      {children}
    </ComparisonContext.Provider>
  );
};